'use client';

import { HorizontalOverflowCarouselItem } from '@petsmart-ui/sparky';
import type { ReactNode } from 'react';

interface ProductCarouselTrackerProps {
    children: ReactNode;
    dataTestId?: string;
    onTrack: () => void;
}

export function ProductCarouselTracker({ children, dataTestId, onTrack }: Readonly<ProductCarouselTrackerProps>) {
    return (
        <HorizontalOverflowCarouselItem data-testid={dataTestId} onClickCapture={onTrack}>
            {children}
        </HorizontalOverflowCarouselItem>
    );
}
